import { Action, AnyAction, createStore, Reducer, Store } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import { composeWithDevTools } from 'redux-devtools-extension';
import storageSession from 'redux-persist/lib/storage/session';
import reducers from './reducers';
const storageConfig = {
	key: 'root', // 必须有的
	storage: storageSession, // 缓存机制
	whitelist: ['loginStatus', 'currentPageType', 'userInfo', 'userLang'], // reducer 里不持久化的数据,除此外均为持久化数据
};
const myPersistReducer = persistReducer(
	storageConfig,
	reducers as Reducer<unknown, Action<unknown>>,
);
const store = createStore(myPersistReducer, composeWithDevTools());
export const persistor = persistStore(store as Store<unknown, AnyAction>);

export default store;
